export default __webpack_public_path__ + "static/media/hex.610f0d8a.svg";